export interface UpdateAdmOfertaValidacionRequest{
    idOferta : number;
    idnotificacionDeOferta : number;
    Estatus :EstatusOfertaEmpresaType;
    puesto : string;
}
export enum EstatusOfertaEmpresaType
{
        Creada = 1,
        Aprobada = 2,
        Rechazada = 3
}